import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer } from '../styles';

const ClosingPage = ({ background, user, number }) => {
  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h3>{user?.name || 'Despedida'}</h3>
          <p className='justified'>
            Esperamos que este informe te haya servido para reflexionar sobre
            tus intereses y te ayude a tomar una mejor decisión al momento de
            elegir tus asignaturas de profundización. Elegir no siempre es
            fácil, pero tener más claridad sobre lo que te gusta y lo que te
            motiva puede marcar una gran diferencia.
          </p>
          <p className='justified'>
            También pudiste conocer un poco más sobre tus preferencias
            vocacionales y tus forma de estudiar. Recuerda que la decisión sobre
            qué carrera seguir no se toma de una sola vez: se va construyendo
            paso a paso, explorando, conversando, probando y conociendo nuevas
            opciones.{' '}
            <strong>
              Lo más importante es que sigas abierto/a a descubrir, y que las
              decisiones que tomes te ayuden a construir un camino que tenga
              sentido para ti
            </strong>
            .
          </p>
          <p className='justified'>
            Si viste aspectos que podrías mejorar en tu forma de estudiar, ¡es
            un buen momento para hacerlo! Todavía hay tiempo para avanzar con
            calma, confianza y motivación.
          </p>
          <br />
          <p className='text-center'>
            <strong>¡Te deseamos mucho éxito en lo que viene!</strong>
          </p>
          <p className='text-center'>Equipo Edumetrics</p>

          <br />
          <br />
          <br />
          <br />
          <br />

          <div className='text-center'>
            <p>
              También puedes visitar el siguiente QR para revisar tus resultados
              online:
            </p>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignContent: 'center',
              marginTop: 16

              // width: '100%'
              // display: 'flex',
              // justifyContent: 'center'
            }}
          >
            <img
              src={`https://www.edumetrics.cl/api/qr?url=https://www.edumetrics.cl/report/${user?.responseId}?k=${user?.responseAccessKey}`}
              alt='qr code'
              style={{
                width: 100,
                height: 100,
                display: 'block'
              }}
            />
          </div>
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default ClosingPage;
